const themeDocument = {
    widgetInstances: {
        root: {
            widgetId: 'document',
            parentId: '',
            id: 'root',
            properties: {},
            contentPlaceHolders: {
                children: [
                    '29626a27-e555-4cf3-8fba-658bc89702c5',
                    '4692e80b-4d94-4601-9607-a5a2fd55bd1f',
                    'b2cb2eda-dc50-4c6d-bd6a-c8d1738d12d2',
                    '0f060277-547e-4f94-9914-f8d60068206c',
                    'eb6cd1e3-eab8-4f56-8095-5e51c4128442',
                    '64bf5bb9-4482-4273-baba-65dfff6c9f24',
                ],
            },
        },
        '29626a27-e555-4cf3-8fba-658bc89702c5': {
            id: '29626a27-e555-4cf3-8fba-658bc89702c5',
            widgetId: 'Header',
            parentId: 'root',
            properties: {
                styles: '',
                opacity: '',
                blendMode: 'normal',
                decoration: 'none',
                fontFamily: '',
                fontWeight: 'normal',
                wordSpacing: '',
                lineHeight: '',
                textIndent: '',
                color: '',
                fontSize: '',
                horizontalAlignment: '',
                verticalAlignment: '',
                shadow: '',
                blendModeStyle: 'normal',
                backgroundColor: '',
                borderWidth: '',
                borderColor: '',
                borderStyle: 'unset',
                borderRadius: '',
                boxShadow: '',
                margin: '',
                padding: '',
                display: '',
                headings: [
                    {
                        headingLevel: 1,
                        headerText: 'h1.Heading',
                        markerLabel: '',
                    },
                    {
                        headingLevel: 2,
                        headerText: 'h2.Heading',
                        markerLabel: '',
                    },
                    {
                        headingLevel: 3,
                        headerText: 'h3.Heading',
                        markerLabel: '',
                    },
                    {
                        headingLevel: 4,
                        headerText: 'h4.Heading',
                        markerLabel: '',
                    },
                    {
                        headingLevel: 5,
                        headerText: 'h5.Heading',
                        markerLabel: '',
                    },
                    {
                        headingLevel: 6,
                        headerText: 'h6.Heading',
                        markerLabel: '',
                    },
                ],
            },
            contentPlaceHolders: {
                children: [],
            },
        },
        '4692e80b-4d94-4601-9607-a5a2fd55bd1f': {
            id: '4692e80b-4d94-4601-9607-a5a2fd55bd1f',
            widgetId: 'Text',
            parentId: 'root',
            properties: {
                styles: '',
                opacity: '',
                blendMode: 'normal',
                decoration: 'none',
                fontFamily: '',
                fontWeight: 'normal',
                wordSpacing: '',
                lineHeight: '',
                textIndent: '',
                color: '',
                fontSize: '',
                horizontalAlignment: '',
                verticalAlignment: '',
                shadow: '',
                blendModeStyle: 'normal',
                backgroundColor: '',
                borderWidth: '',
                borderColor: '',
                borderStyle: 'unset',
                borderRadius: '',
                boxShadow: '',
                margin: '',
                padding: '',
                display: '',
                textInput: 'Text Widget',
                isTransformData: false,
            },
            contentPlaceHolders: {
                children: [],
            },
        },
        'b2cb2eda-dc50-4c6d-bd6a-c8d1738d12d2': {
            id: 'b2cb2eda-dc50-4c6d-bd6a-c8d1738d12d2',
            widgetId: 'TitledSection',
            parentId: 'root',
            properties: {
                styles: '',
                opacity: '',
                blendMode: 'normal',
                decoration: 'none',
                fontFamily: '',
                fontWeight: 'normal',
                wordSpacing: '',
                lineHeight: '',
                textIndent: '',
                color: '',
                fontSize: '',
                horizontalAlignment: '',
                verticalAlignment: '',
                shadow: '',
                blendModeStyle: 'normal',
                backgroundColor: '',
                borderWidth: '',
                borderColor: '',
                borderStyle: 'unset',
                borderRadius: '',
                boxShadow: '',
                margin: '',
                padding: '',
                display: '',
                isCollapsible: false,
                toggleSection: false,
                isTransformData: false,
                showToolTip: false,
                tooltipOptions: {
                    iconName: 'fas fa-info-circle',
                },
                title: 'Titled Section',
                defaultCollpsible: 'Show',
                defaultActiveSection: 'on',
            },
            contentPlaceHolders: {
                children: ['43db383e-86c7-43d4-bb90-050dcecafe39'],
            },
        },
        'eb6cd1e3-eab8-4f56-8095-5e51c4128442': {
            id: 'eb6cd1e3-eab8-4f56-8095-5e51c4128442',
            widgetId: 'Table',
            parentId: 'root',
            properties: {
                columns: [
                    {
                        label: 'Series',
                        value: '{{ series }}',
                    },
                    {
                        label: '1 mth',
                        value: '{{ 1mth}}',
                    },
                    {
                        label: '3 mth',
                        value: '{{ 3mth }}',
                    },
                    {
                        label: '6 mth',
                        value: '{{ 6mth}}',
                    },
                    {
                        label: '1 yr',
                        value: '{{ 1yr}}',
                    },
                    {
                        label: '3 yr',
                        value: '{{ 3yr }}',
                    },
                    {
                        label: '5 yr',
                        value: '{{ 5yr }}',
                    },
                    {
                        label: '10 yr',
                        value: '{{ 10yr }}',
                    },
                    {
                        label: 'Since Inception',
                        value: '{{ sinceInception }}',
                    },
                ],
                rows: 'tableData',
            },
            contentPlaceHolders: {
                children: [],
            },
        },
        '0f060277-547e-4f94-9914-f8d60068206c': {
            id: '0f060277-547e-4f94-9914-f8d60068206c',
            widgetId: 'KeyValuePairTable',
            parentId: 'root',
            properties: {
                tableItems: [
                    {
                        key: 'sampleKey1',
                        valueType: 'String',
                        value: 'sampleValue1',
                    },
                    {
                        key: 'sampleKey2',
                        valueType: 'String',
                        value: 'sampleValue2',
                    },
                    {
                        key: 'sampleKey3',
                        valueType: 'String',
                        value: 'sampleValue3',
                    },
                ],
            },
            contentPlaceHolders: {},
        },
        '64bf5bb9-4482-4273-baba-65dfff6c9f24': {
            id: '64bf5bb9-4482-4273-baba-65dfff6c9f24',
            widgetId: 'GrowthChart',
            parentId: 'fa60660f-4f1e-4483-9bac-4565cca8fd38',
            properties: {
                styles: 'font-size: 0.8rem;\nmargin-top: 1rem;\n\n.date-picker-conatiner {\n  left: 24rem;\n}\n\n.start-date-container {\n  margin-right: 0.5rem !important;\n}\n\n.start-date-month-input, .end-date-month-input {\n  width: 4rem;\n}\n\n.total-returns {\n  left: 48rem;\n}\n\n.highcharts-data-labels{\n      transform: translate(55px, 96px);\n}\n\n@media only screen and (min-width: 320px) and (max-width: 769px) {\n  .date-picker-conatiner{\n    position: static !important;\n    left: none !important;\n    top: none !important;\n  }\n  \n  .total-returns{\n    position: static !important;\n    left: none !important;\n    top: none !important;\n  }\n}\n\n\n@media only screen and (min-width: 320px) and (max-width: 425px) {\n  div[data-highcharts-chart="0"] > div:first-of-type:before{\n    content: "Duration";\n    position: absolute;\n    top: 10px;\n    left: 45px;\n    font-size: 12px;\n    font-weight: bold;\n  }\n    font-size: 11px;\n}',
                opacity: '',
                blendMode: 'normal',
                decoration: 'none',
                fontFamily: '',
                fontWeight: 'normal',
                wordSpacing: '',
                lineHeight: '',
                textIndent: '',
                color: '',
                fontSize: '',
                horizontalAlignment: '',
                verticalAlignment: '',
                shadow: '',
                blendModeStyle: 'normal',
                backgroundColor: '',
                borderWidth: '',
                borderColor: '',
                borderStyle: 'unset',
                borderRadius: '',
                boxShadow: '',
                margin: '',
                padding: '',
                display: '',
                dataKey: 'performance.growth[*isCurrent=true]',
                chartType: 'area',
                showDateInput: true,
                showInvestmentAmount: true,
                showChartRange: true,
                showTotalReturns: true,
                showDifferentZone: true,
                transformData: true,
                options: [
                    {
                        path: 'plotOptions.area',
                    },
                    {
                        path: 'navigator',
                        value: '{"series": {"fillOpacity": 1}}',
                    },
                    {
                        path: 'plotOptions.series',
                    },
                    {
                        path: 'rangeSelector',
                        value: '{   "allButtonsEnabled": true }',
                    },
                ],
                rangeButtons:
                    '[   {     "count": 1,     "preserveDataGrouping": true,     "text": "1W",     "title": "View one week",     "type": "week"   },   {     "count": 1,     "preserveDataGrouping": true,     "text": "1M",     "title": "View one month",     "type": "month"   },   {     "preserveDataGrouping": true,     "text": "YTD",     "title": "View year to date",     "type": "ytd", "offsetMin": -86400000 },   {     "count": 1,     "preserveDataGrouping": true,     "text": "1Y",     "title": "View one year",     "type": "year"   },   {     "count": 5,     "preserveDataGrouping": true,     "text": "5Y",     "title": "View five years",     "type": "year"   },   {     "count": 10,     "preserveDataGrouping": true,     "text": "10Y",     "title": "View ten years",     "type": "year"   },   {     "preserveDataGrouping": true,     "text": "All",     "title": "View all",     "type": "all"   } ]',
                datePickerOptions: {
                    startDateLabel: 'Start Date',
                    endDateLabel: 'End Date',
                    startDayAriaLabel: '{{ resourceStrings.startDay }}',
                    startMonthAriaLabel: '{{ resourceStrings.startMonth }}',
                    startYearAriaLabel: '{{ resourceStrings.startYear }}',
                    endDayAriaLabel: '{{ resourceStrings.endDay }}',
                    endMonthAriaLabel: '{{ resourceStrings.endMonth }}',
                    endYearAriaLabel: '{{ resourceStrings.endYear }}',
                },
                toolTipValueFormat: 'curMax2',
                toolTipDateFormat: 'dateMed',
                isLimitToTenYears: false,
                growthAmountLabel: 'Investment amount $:',
                initialGrowthAmount: 10000,
                totalReturnsLabel: 'Total return for this timeframe',
                zoneOptions: {
                    year: '{{ overview.inceptionDate }}',
                },
                functionToTransform:
                    "return (data) => { \nconst growthChartData = data.growthChartData;\nconst underlyingFundPath= 'overview.underlyingFund.growth';  \nconst underlyingGrowth = data.JsonQuery(`${underlyingFundPath}`, { data: data.data }).value;\n\nconst rebaseChartData = (newInput, preparedData, nextPoint) => {\n    const diff = newInput / nextPoint.value;\n    const mappedData = [];\n    preparedData.forEach(function (point) {\n        mappedData.push({ date: point.date, value: point.value * diff })\n    });\n    return mappedData;\n}\n\nif (underlyingGrowth?.length > 0) {\nconst underlyingData = underlyingGrowth?.filter(d => new Date(d.date) < new Date(data.data?.overview?.inceptionDate));\n            let values = growthChartData[0].values;\n            values.map((v) => {\n                const underlyingValue = underlyingData.find((d) => new Date(d.date) === new Date(v.date));\n                if (underlyingValue) {\n                    return underlyingValue;\n                }\n                return v;\n            });\n\n            \n    values = rebaseChartData(underlyingData[underlyingData.length -1].value, values, values[0]);\n\n            growthChartData[0] = {\n                ...growthChartData[0],\n                values: [...underlyingData, ...values],\n            };\n        }\n\n  return { ...data, growthChartData }\n}",
                chartTitle: 'Fund: $9,867.30 at Dec 12, 2018',
                noDataMessage: '',
            },
            contentPlaceHolders: {
                children: [],
            },
        },
    },
    documentAttributes: {},
};

export default themeDocument;
